<template>
  <el-dialog ref="dialog" :visible.sync="visible" title="下载文件" width="65%" :height="height"
             :append-to-body="true" :close-on-click-modal="false" :modal-append-to-body="true"
             @size-change="handleResizeChange">
    <x-page-container class="common-page-container">
      <template v-slot:header>
        <span class="label">文件名：</span>
        <el-input v-model="queryParams.name" placeholder="名称" @keyup.enter.native="search"
                  style="width: 150px; margin-right: 5px"></el-input>
        <el-button
          class="search-button"
          type="primary"
          @click="search"
        >查询
        </el-button>
        <el-button
          type="danger"
          @click="batchDelete"
        >批量删除
        </el-button>
      </template>
      <template v-slot:main>
        <vxe-table
          ref="table"
          :data="tableList"
          border
          height="100%"
        >
          <vxe-table-column width="50" type="checkbox" header-align="center" align="center"></vxe-table-column>
          <vxe-table-column field="userName" title="用户名" width="100" header-align="center"
                            align="left"></vxe-table-column>
          <vxe-table-column field="fileName" title="文件名" min-width="150" header-align="center" align="left"></vxe-table-column>
          <vxe-table-column field="status" :formatter="formatState" title="状态" width="120" header-align="center"
                            align="left"></vxe-table-column>
          <vxe-table-column field="createTime" title="创建时间" width="155" header-align="center"
                            align="left"></vxe-table-column>
          <vxe-table-column field="filePath" title="下载地址" width="200" show-overflow="tooltip" header-align="center"
                            align="left"></vxe-table-column>
          <vxe-table-column title="操作" width="200" header-align="center" align="center">
            <template v-slot:default="scope">
              <el-button
                v-if="scope.row.status === 'SUCCESS' || scope.row.downloadState === 'SUCCESS'"
                type="primary"
                @click="downloadFile(scope.row)"
              >下载
              </el-button>
              <el-button
                type="danger"
                @click="confirmDelete([scope.row.id])"
              >删除
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
      </template>
      <template v-slot:footer>
        <el-pagination
          background
          @size-change="pageSizeChange"
          @current-change="currentPageChange"
          :current-page="queryParams.page"
          :page-sizes="[10,20,30,50]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </template>
    </x-page-container>
  </el-dialog>
</template>

<script>
import { downloadFile } from '../../util/downloadFile';
import { Pagination, Button, Input } from 'element-ui';
import { Table, Column } from 'vxe-table';
import {Notification} from'element-ui';

export const EVENT_DOWNLOAD_START = 'download-start';
export default {
  name: 'XDownloadDialog',
  inheritAttrs: false,
  components: {
    [Pagination.name]: Pagination,
    [Button.name]: Button,
    [Table.name]: Table,
    [Column.name]: Column,
    [Input.name]: Input
  },
  props: {
    columns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    downloadApi: {
      type: Function
    },
    listDownloadApi: {
      type: Function
    },
    deleteDownloadApi: {
      type: Function
    },
    downloadParams: {
      type: Object
    },
    // excel的配置
    excelConfig: {
      type: Object,
      default() {
        /*
          * {fileName: '文件名', sheetName: 'sheet名称'}
          * */
        return null;
      }
    },
    height: {
      type: String,
      default: '70vh'
    }
  },
  data() {
    return {
      // 分页参数
      queryParams: {
        name: '', // 名称
        page: 1, // 当前页
        pageSize: 10 // 分页大小
      },
      // 总记录数
      total: 0,
      tableList: [],
      visible: false
    };
  },
  methods: {
    handleResizeChange(args) {
      this.$nextTick(() => {
        this.$refs.table.recalculate(true);
      });
    },
    download() {
      const params = { jsonStr: JSON.stringify(this.downloadParams) };
      if (this.excelConfig) {
        params.excelConfigJson = JSON.stringify(this.excelConfig);
      }
      this.handleDownload(this.downloadApi(params));
    },
    simpleDownload() {
      const downloadParams = JSON.parse(JSON.stringify(this.downloadParams));
      if (this.excelConfig) {
        downloadParams.excelConfigJson = JSON.stringify(this.excelConfig);
      }
      this.handleDownload(this.downloadApi(downloadParams));
    },
    handleDownload(promise) {
      promise.then(response => {
        const res = response.data;
        if (!res.isSuccess()) {
          return Promise.reject(new Error(res.msg));
        }
        Notification.success(
          '下载任务已开始，请从下载列表查看进度及下载文件'
        );
        this.$emit(EVENT_DOWNLOAD_START, { id: res.data });
      }).catch((error) => {
        this.$emit(EVENT_DOWNLOAD_START, null);
        if (error instanceof Error) {
          Notification.error(error.message);
          return;
        }
        Notification.success('导出失败，请与管理员联系');
      });
    },
    confirmDelete(arr) {
      this.$confirm('确认进行删除操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteDownload(arr);
      });
    },
    // 删除所选，批量删除
    deleteDownload(idArr) {
      this.deleteDownloadApi(idArr.join(',')).then(response => {
        const res = response.data;
        if (!res.isSuccess()) {
          Notification.error(res.msg); // 提示错误
          return;
        }
        Notification.success('删除成功');
        // 如果这一页已经没有数据了，且这一页是最后一页，就要加载前一页
        const page = Math.ceil(this.total / this.queryParams.pageSize);
        if (idArr.length === this.tableList.length && this.queryParams.page === page) {
          // 如果减完后是0，就默认显示第一页
          this.queryParams.page = this.queryParams.page - 1 || 1;
        }
        this.loadingData();
      });
    },
    async downloadFile(row) {
      // const url = await createFileUrl({url: row.filePath});
      const url = row.filePath;
      downloadFile(url, row.fileName);
      // window.open(path, '_me');
    },
    // 分页大小修改事件
    pageSizeChange(val) {
      this.queryParams.pageSize = val;
      this.loadingData();
    },
    // 当前页修改事件
    currentPageChange(val) {
      this.queryParams.page = val;
      this.loadingData();
    },
    formatState({ row }) {
      const status = row.status || row.downloadState;
      if (status === 'SUCCESS') {
        return '下载成功';
      }
      if (status === 'FAIL') {
        return '下载失败';
      }
      if (status === 'PROCESSING') {
        return '处理中';
      }
      if (status === 'WAIT') {
        return '等待下载';
      }
      if (status === 'QUERY') {
        return '正在查询数据';
      }
      return '未知';
    },
    reload() {
      this.queryParams.name = '';
      this.queryParams.page = 1;
      this.loadingData();
    },
    // 加载数据
    loadingData() {
      this.listDownloadApi(this.queryParams).then(async (response) => {
        const res = response.data;
        if (!res.isSuccess()) {
          Notification.error(res.msg); // 提示错误
          return;
        }
        if (Array.isArray(res.data.list)) {
          this.tableList = res.data.list;
        } else {
          this.tableList = [];
        }
        this.total = res.data.totalRows;
      });
    },
    // 批量删除
    batchDelete() {
      const rows = this.$refs.table.getCheckboxRecords();
      if (rows.length < 1) {
        Notification.error('请选择记录');
        return false;
      }
      const arr = [];
      for (const item of rows) {
        arr.push(item.id);
      }
      this.confirmDelete(arr);
    },
    // 表格搜索
    search() {
      this.queryParams.page = 1;
      this.loadingData();
    },
    show() {
      this.visible = true;
      this.reload();
    }
  }
};
</script>
